// Please: Alphabetize the exports
export const CUSTOM_SMS_LEGAL_DISCLAIMER = 'custom_sms_legal_disclaimer'
export const DOMAIN_CONTROL = 'domain_control'
